import { render, staticRenderFns } from "./searchResults27.vue?vue&type=template&id=75bd5621&scoped=true&"
import script from "./searchResults27.vue?vue&type=script&lang=js&"
export * from "./searchResults27.vue?vue&type=script&lang=js&"
import style0 from "./searchResults27.vue?vue&type=style&index=0&id=75bd5621&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bd5621",
  null
  
)

export default component.exports